export default __webpack_public_path__ + "static/media/Group290.88c96f12.png";